import { LIST_GENDER } from "../LocalConst";

export class CheckOut {
  department = null;
  receptionist = null;
  checkoutTime = new Date();
}
